import { runActionSideEffect } from '../../util/StoreUtils';
import { UserFriendlyError } from '../../util/UserFriendlyError';
import { ActionType } from '../ActionTypes';
import { LOADED_STATE, LOADING_STATE } from '../LoadingAndErrorState';
import { store, StoreAction } from '../Store';
import { grantUs65PlusAccess } from './effects/GrantUs65PlusAccess';
import { INITIAL_US_65_PLUS_STATE, Us65PlusState } from './Us65PlusState';

export type Us65PlusAction = {
  type: ActionType.GRANT_US_65_PLUS_ACCESS;
};

export type PrivateUs65PlusAction =
  | {
      type: ActionType.GRANT_US_65_PLUS_ACCESS_LOADING;
    }
  | {
      type: ActionType.GRANT_US_65_PLUS_ACCESS_SUCCESS;
    }
  | {
      type: ActionType.GRANT_US_65_PLUS_ACCESS_FAILURE;
      error: UserFriendlyError;
    };

export function us65PlusReducer(state: Us65PlusState, action: StoreAction): Us65PlusState {
  switch (action.type) {
    case ActionType.GRANT_US_65_PLUS_ACCESS: {
      runActionSideEffect(grantUs65PlusAccess, { fromGrantScreen: true });
      return state;
    }
    case ActionType.GRANT_US_65_PLUS_ACCESS_LOADING: {
      return { ...INITIAL_US_65_PLUS_STATE, ...LOADING_STATE };
    }
    case ActionType.GRANT_US_65_PLUS_ACCESS_SUCCESS: {
      return { ...LOADED_STATE, granted: true };
    }
    case ActionType.GRANT_US_65_PLUS_ACCESS_FAILURE: {
      return { loading: false, error: action.error, granted: false };
    }
    default:
      return state;
  }
}

export function dispatchGrantUs65PlusAccess(): void {
  store.dispatch({ type: ActionType.GRANT_US_65_PLUS_ACCESS });
}
